<template>
  <div id="app" :class="{'app-en':isEN=='en'}">
    <router-view/>
	<!-- loading -->
	<div class="modal" v-show="showLoad">
		<div class="modal-bg"></div>
		<div class="modal-content" style="width:100%;left:0;">
			<div class="loadBox ac">
				<div class="load-bg"></div>
				<div class="loadCont">
					<img src="static/images/loading.gif"/>
					<p>{{$t('loading')}} ...</p>
				</div>
			</div>
		</div>
	</div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
	return{
		showLoad:'',
    isEN:'bur',
	}
  },
  created(){
    if(localStorage.getItem('lang')) this.isEN = localStorage.getItem('lang')
  },
	methods: {
		// code判断
		returnCode (data,callback) {
			let code = data.code;
      console.log(code)
      //callback();
			if(code == 1){
				callback();
			}else if(code==101){
				this.showLoad = false;
				this.$router.push('/land');
			}else{
				this.showLoad = false;
				this.$utils.alertText(data.msg,80);
			}
		},
		loadModal(isShow){
			let that = this;
			that.showLoad = isShow;
		}
	}
}
</script>

<style>
	@import "./style/style.css";
	.modal{position:fixed;top:0;left:0;width:100%;height:100%;z-index:999;}
	.modal-bg{width:100%;height:100%;background:rgba(0,0,0,.5);}
	.modal-content{position:absolute;top:50%;left:50%;transform:translate(0,-50%);}
	.loadCont p{color:#fff;margin:10px 0 0;}
</style>



// WEBPACK FOOTER //
// src/App.vue